import { passengerTypeAction } from "../../../Actions/Index";
import { getPassengerDetailsAction } from "../../../Actions/LogicActions/Checkout/PassengerDetails/GetPassengerDetailsAction";
import { changeTrainAction, IChangeTrainActionParams } from "../../../Actions/LogicActions/MultiBooking/ChangeTrainAction";
import { getTrainChangeOfferAction, IGetChangeTrainOfferActionParams } from "../../../Actions/LogicActions/MultiBooking/GetChangeTrainOffersAction";
import { getMultiBookingTripOfferAction, IGetMultiBookingTripOfferActionParams } from "../../../Actions/LogicActions/MultiBooking/GetMultiBookingTripOfferAction";
import { prebookMultiBookingAction } from "../../../Actions/LogicActions/MultiBooking/PrebookMultiBookingAction";
import { toggleMultiBookingTrainCheckboxAction } from "../../../Actions/LogicActions/MultiBooking/ToggleMultiBookingTrainCheckboxAction";
import { getSearchResultAction } from "../../../Actions/LogicActions/Search/GetSearchResultAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { multiBookTree } from "../../../Orchestrator/ConstantTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IMultiBookingTrainOffer } from "../../../Orchestrator/Recoils/MultiBookingAtom";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { showNotification } from "../../../Services/notificationService";
import { MultiBookingContext } from "../Context/MultiBookingContext";

class MultiBookingInitStep extends StepFlow {
    get stepName() { return "MultiBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: multiBookTree.MultiBook.Back.Click,
                handler: () => {
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/plan-multi-book",
                    });
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "MultiBookingFlow",
                    });
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IGetMultiBookingTripOfferActionParams, void>({
                eventName: multiBookTree.MultiBook.ModifyDate,
                handler: async ({ data }) => {
                    getMultiBookingTripOfferAction.setParams(data!);
                    await getMultiBookingTripOfferAction.execute();
                    if (!isActionRunSuccessfully(getMultiBookingTripOfferAction)) {
                        showNotification(
                            "error",
                            "Error",
                            getTranslatedMessage('multiBooking.failToRetrieveBookingOffer', "")
                        )
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: multiBookTree.MultiBook.Continue.Click,
                handler: async (payload) => {
                    prebookMultiBookingAction.setParams();
                    await prebookMultiBookingAction.execute();

                    if (isActionRunSuccessfully(prebookMultiBookingAction)) {
                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "MultiBookingFlow",
                        });

                        const multiBookingContext = this.getCtx<MultiBookingContext>("multiBookingContext");
                        if (multiBookingContext) {
                            multiBookingContext.routeTo = ["CheckoutFlow"];
                            this.next();
                        }

                        setTimeout(() => {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/checkout"
                            });
                        }, 0);
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{
                type: TrainTypeEnum,
                train: IMultiBookingTrainOffer
            }, void>({
                eventName: multiBookTree.MultiBook.Booking.Checkbox.Click,
                handler: async (payload) => {
                    toggleMultiBookingTrainCheckboxAction.setParams(payload.data!);
                    await toggleMultiBookingTrainCheckboxAction.run();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IGetChangeTrainOfferActionParams, void>({
                eventName: multiBookTree.MultiBook.ChangeTrain.GetOffers,
                handler: async (payload) => {
                    getTrainChangeOfferAction.setParams(payload.data!);
                    await getTrainChangeOfferAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IChangeTrainActionParams, void>({
                eventName: multiBookTree.MultiBook.ChangeTrain.SelectOffer,
                handler: async (payload) => {
                    changeTrainAction.setParams(payload.data!);
                    changeTrainAction.execute();
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("Multi Booking Init Step Execute..........");

        // const passengerRelatedAtoms = [
        //     "passengerStateAtom",
        //     "passengerTypesStateAtom",
        //     "selectedPassengersPerTypeStateAtom",
        //     "savedPassengerDetailAtom",
        //     "passengerMappingAtom",
        //     "areAllPassengerDetailsCompleteAtom",
        //     "selectedPassengerForCancelAtom",
        //     "selectedPassengerForCancelInBoundAtom",
        //     "selectedPassengersAtom",
        //     "allPassengerPriceAndAgeGroupAtom",
        //     "allPassengerPriceAndAgeGroupInBoundAtom",
        //     "selectedPassengersOutBoundAtom",
        //     "selectedPassengersInBoundAtom",
        //     "selectedPassengerForDateChangeAtom",
        //     "selectedPassengerForDateChangeInBoundAtom",
        //     "displayPassengerDataAtom",
        //     "passengerSeatCursorAtom"
        // ];

        // const STORAGE_PREFIX = 'recoil_state_';
        // passengerRelatedAtoms.forEach(atomKey => {
        //     try {
        //         const storageKey = `${STORAGE_PREFIX}${atomKey}`;
        //         localStorage.removeItem(storageKey);
        //     } catch (error) { }
        // });

        // updateRecoilState("passengerStateAtom", []);
        // updateRecoilState("selectedPassengersPerTypeStateAtom", {});
        // updateRecoilState("savedPassengerDetailAtom", []);
        // updateRecoilState("passengerMappingAtom", []);
        // updateRecoilState("areAllPassengerDetailsCompleteAtom", false);

        await passengerTypeAction.execute();
        await getPassengerDetailsAction.execute();
        updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
    }
}

export const MultiBookingInitStepDeclaration = new StepDefinition({
    stepName: "MultiBookingInit_Step",
    stepClass: MultiBookingInitStep
});